export const GET_MENU_API_REQUEST = "GET_MENU_API_REQUEST";
export const GET_MENU_API_SUCCESS = "GET_MENU_API_SUCCESS";
export const GET_MENU_API_ERROR = "GET_MENU_API_ERROR";